import {ValueListener} from "./interfaces";
import {observeIsAnythingLocked} from "./observeIsAnythingLocked";
import {observeProcessedEventAclRole} from "./observeProcessedEventAclRole";
import {observeAskingAttendingRsvpQuestion} from "./observeAskingAttendingRsvpQuestion";
import {observeCurrentUserProfile} from "./observeCurrentUserProfile";
import {observeIncompleteResponses} from "./observeIncompleteResponses";
import {checkForPrivateEvents} from "./checkForPrivateEvents";

export const enum CTAState {
    SiteLockedIncludeQs = "SiteLockedIncludeQs",
    SiteLockedExcludeQs = "SiteLockedExcludeQs",
    SiteUnlockedExcludeQs = "SiteUnlockedExcludeQs",
    SiteUnlockedIncludeQs = "SiteUnlockedIncludeQs",
    SiteunlockedResponded = "SiteUnlockedResponded",
    SiteLockedHasPrivateEventsIncludeQs = "SiteLockedHasPrivateEventsIncludeQs",
    SiteLockedHasPrivateEventsExcludeQs = "SiteLockedHasPrivateEventsExcludeQs",
    SiteUnlockedHasPrivateEventsIncludeQs = "SiteUnlockedHasPrivateEventsIncludeQs",
    SiteUnlockedHasPrivateEventsExcludeQs = "SiteUnlockedHasPrivateEventsExcludeQs",
}
export interface Cta {
    prompt: string,
    state: string,
    label: string,
    lockLabel: string,
    navigationTitle: string
};

export const observeCta = (eventDataSource: any, listener: ValueListener<Cta>) => {
    let websiteNeedsUnlocking;
    let processedRole;
    let askingAttendingRsvpQ;
    let responseWorkflowExists;
    let userProfile;
    let incompleteResponse;
    let RSVPTitle;
    let hasPrivateEvents;

    listener = eventDataSource.wrapListener(listener);

    const compute = function () {
        const cta: Cta = {
            prompt: null,
            state: null,
            label: null,
            lockLabel: null,
            navigationTitle: null,
        };

        // cta prompt
        const nullGreeting = `Hello!`

        if (userProfile && websiteNeedsUnlocking) {
            cta.prompt = userProfile.displayName ? `Hello ${userProfile.displayName}!` : nullGreeting;
        } else if (userProfile && !websiteNeedsUnlocking) {
            cta.prompt = userProfile.displayName ? `Welcome back, ${userProfile.displayName}!` : nullGreeting;
        } else if (processedRole.isCrasher) {
            cta.prompt = nullGreeting;
         }

        // cta label / state
        if (websiteNeedsUnlocking) {
            cta.lockLabel = 'Guest only details';
        } else if (hasPrivateEvents) {
            cta.lockLabel = 'Find My Invite';
        }

        if (hasPrivateEvents && !userProfile.personKey) {
            if (processedRole.isCrasher && websiteNeedsUnlocking) {
                cta.state = CTAState.SiteLockedHasPrivateEventsExcludeQs;
                if (responseWorkflowExists) {
                    cta.label = RSVPTitle ? RSVPTitle : `RSVP Here`;
                    cta.navigationTitle = cta.label;
                    cta.state = CTAState.SiteLockedHasPrivateEventsIncludeQs;
                }
            } else if(responseWorkflowExists && askingAttendingRsvpQ) {
                cta.state = CTAState.SiteUnlockedHasPrivateEventsIncludeQs;
                //users customOverride;
                cta.label = RSVPTitle ? RSVPTitle : `RSVP Here`;
                cta.navigationTitle = cta.label;
                //if user has already RSVPed and household RSVPs
                if(userProfile && (userProfile.attending === true || userProfile.attending === false)) {
                    cta.state = CTAState.SiteunlockedResponded;
                    if(userProfile.attending) {
                        cta.label = `You Are Attending` +
                            (userProfile.householdAttendance && userProfile.householdAttendance > 1 ? ` (${userProfile.householdAttendance})` : ``);
                    }
                    //user has said they are not attending
                    else if(userProfile.attending === false) {
                        cta.label = `You Are Not Attending`;
                    }
                }
                return cta;
            } else if (responseWorkflowExists && !askingAttendingRsvpQ) {
                cta.state = CTAState.SiteUnlockedHasPrivateEventsIncludeQs;
                cta.label = RSVPTitle ? RSVPTitle : `RSVP Here`;
                cta.navigationTitle = cta.label;
            } else {
                cta.state = CTAState.SiteUnlockedHasPrivateEventsExcludeQs;
            }
        } else {
            if (processedRole.isCrasher && websiteNeedsUnlocking) {
                cta.state = CTAState.SiteLockedExcludeQs
                if (responseWorkflowExists) {
                    cta.label = RSVPTitle ? RSVPTitle : `RSVP Here`;
                    cta.navigationTitle = cta.label;
                    cta.state = CTAState.SiteLockedIncludeQs
                }
            } else if(responseWorkflowExists && askingAttendingRsvpQ) {
                cta.state = CTAState.SiteUnlockedIncludeQs;
                //users customOverride;
                cta.label = RSVPTitle ? RSVPTitle : `RSVP Here`;
                cta.navigationTitle = cta.label;
                //if user has already RSVPed and household RSVPs
                if(userProfile && (userProfile.attending === true || userProfile.attending === false)) {
                    cta.state = CTAState.SiteunlockedResponded;
                    if(userProfile.attending) {
                        cta.label = `You Are Attending` +
                            (userProfile.householdAttendance && userProfile.householdAttendance > 1 ? ` (${userProfile.householdAttendance})` : ``);
                    }
                    //user has said they are not attending
                    else if(userProfile.attending === false) {
                        cta.label = `You Are Not Attending`;
                    }
                }
                return cta;
            } else if (responseWorkflowExists && !askingAttendingRsvpQ) {
                cta.state = CTAState.SiteUnlockedIncludeQs;
                cta.label = RSVPTitle ? RSVPTitle : `RSVP Here`;
                cta.navigationTitle = cta.label;
            } else {
                cta.state = CTAState.SiteUnlockedExcludeQs
            }
        }
        return cta;
    };

    const onUpdate = function () {
        const anyUndef = ([websiteNeedsUnlocking,
            processedRole,
            askingAttendingRsvpQ,
            responseWorkflowExists,
            userProfile,
            incompleteResponse,
            hasPrivateEvents].filter(x => (typeof x == "undefined")).length > 0);
        if (anyUndef) {
            return;
        }

        listener.onValue(compute());
    };

    observeIsAnythingLocked(eventDataSource, {onValue: isAnythingLocked => {
        websiteNeedsUnlocking = isAnythingLocked;
        onUpdate();
    }});

    observeProcessedEventAclRole(eventDataSource, {onValue: r => {
        processedRole = r;
        onUpdate();
    }});

    observeAskingAttendingRsvpQuestion(eventDataSource, { onValue: b => {
        askingAttendingRsvpQ = b;
        onUpdate();
    }});

    observeCurrentUserProfile(eventDataSource, { onValue: p => {
        userProfile = p;
        onUpdate();
    }});

    observeIncompleteResponses(eventDataSource, { onValue: s => {
        incompleteResponse = s;
        onUpdate();
    }});

    eventDataSource.observePageConfig({onValue: function (pagesConfig) {
        responseWorkflowExists = Boolean(pagesConfig.RSVP);
        onUpdate();
    }});

    eventDataSource.observeRSVPTitle({onValue: t => {
        RSVPTitle = t;
        onUpdate();
    }});

    checkForPrivateEvents(eventDataSource, { onValue: p => {
        hasPrivateEvents = p;
        onUpdate();
    }});
};
